import  './footer.scss'
import {FaFacebookSquare, FaInstagram, FaLinkedinIn, FaLongArrowAltRight, FaTwitter, FaYoutube} from 'react-icons/fa'
const Footer = () => {
  return (
    <section className="footer">
      <div className='footer-main'>
        <div className='part-1'>
          <h4>Get The Latest From Peggerz</h4>
          <div className='email-div'>
            <input type='email' placeholder='Email' className='email-input'/>
            <span>
              <button><FaLongArrowAltRight/></button>
            </span>
          </div>
          <div className='icons'>
              <FaFacebookSquare/>
              <FaTwitter/>
              <FaLinkedinIn/>
              <FaInstagram/>
              <FaYoutube/>
          </div>
        </div>
        <div className='part-2'>
          <h4>Learn</h4>
          <p>About Us</p>
          <p>Download Our App</p>
          <img src="https://cdn.storehippo.com/s/6123687a0e3882eabaee1e6e/ms.files/G-app.png | image:'100x30'" alt='google-play'/>
          <img src="https://cdn.storehippo.com/s/6123687a0e3882eabaee1e6e/ms.files/a-app.png | image:'100x30'" alt='app-store'/>
        </div>
        <div className='part-3'>
          <h4>Help Center</h4>
          <p>Return & Refund Policies</p>
          <p>Patient Disclaimer</p>
          <p>Terms & Conditions</p>
          <p>FAQs</p>
          <p>Account</p>
        </div>
        <div className='part-4'>
          <h4>Contact Us</h4>
          <p>Raise a Query</p>
          <p>care@preggerz.in</p>
          <p>Call Us: +91-8929345355 (Mon-Sat: 10 am to 6 pm)</p>
        </div>
        <div className='part-5'>
          <h4>Work With Us</h4>
          <p>Partner Registration</p>
          <p>Influencer Program</p>
          <p>Join the Team</p>
          <p>Corporate Programs</p>
        </div>
        <div className='part-5'>
          <h4>KA Healthcare Pvt. Ltd.</h4>
          <p>M 11-9, Ground Floor, DLF Phase 2, Gurugram – 120002, Haryana</p>
        </div>
      </div>
      <div className='copyright'>
        <p>COPYRIGHT © 2022 KA HEALTHCARE PVT LTD - ALL RIGHTS RESERVED.</p>
        <p className='disclaimer'>Disclaimer: PREGGERZ does not provide medical advice and does not cater to any medical/Pregnancy or psychiatric emergencies. If you are in a life-threatening situation, please do NOT use this site. If you are feeling suicidal, we recommend you call a suicide prevention helpline or go to your nearest hospital.</p>
      </div>
    </section>
  )
}

export default Footer